/* global THREE */
import whenDomReady from 'when-dom-ready'
import TWEEN from '@tweenjs/tween.js'

let debug = false

let officeScan

// tweakable params

let targetX = 0.5
let startZ = -2
let saturationMultiplier = 1.6

let cameraPositions = {
  initial: { x: -30, y: 1, z: 11 },
  ready:   { x: 0.25, y: 0.2, z: 2.5 },
}
let cameraTweenLength = 2000

// end tweakable params

whenDomReady()
  .then(() => {

    // check for mobile URL arg
    let isMobile = !!parseInt(getQueryVariable('is_mobile'))

    if(isMobile || !Detector.webgl){
      let fallbackvid = new FallbackVid
    } else {
      officeScan = new OfficeScan()
    }

  })

class FallbackVid {
  constructor(){
    let v = this

    v.container = document.querySelector('.video')

    v.video = v.container.querySelector('video')

    v.video.addEventListener('canplaythrough', play, false)
    v.video.addEventListener('play', play, false)

    v.video.src = 'assets/Officespin-600.mp4'

    function play(){
      v.video.removeEventListener('canplaythrough', play, false)
      v.video.removeEventListener('play', play, false)

      v.ratio = v.video.videoHeight / v.video.videoWidth

      window.addEventListener('resize', v.resize.bind(v), false)
      v.resize()

      v.container.classList.add('is-visible')
      document.querySelector('.loader').classList.add('is-hidden')
      v.video.play()
    }
  }

  resize(){
    let dimensions = this.contain(this.ratio)

    this.video.style.top    = dimensions.t + 'px'
    this.video.style.left   = dimensions.l + 'px'
    this.video.style.width  = dimensions.w + 'px'
    this.video.style.height = dimensions.h + 'px'

  }


  cover(ratio){
    var w, h, t, l;

    w = window.innerWidth;
    h = w * ratio;

    if(h < window.innerHeight) {
      h = window.innerHeight;
      w = h / ratio;
    }

    t = (window.innerHeight - h) / 2;
    l = (window.innerWidth - w) / 2;

    return {
      w: Math.round(w),
      h: Math.round(h),
      t: Math.round(t),
      l: Math.round(l)
    }
  }

  contain(ratio){
    var w, h, t, l;
    w = window.innerWidth;
    h = w * ratio;

    if(h > window.innerHeight) {
      h = window.innerHeight;
      w = h / ratio;
    }

    t = (window.innerHeight - h) / 2;
    l = (window.innerWidth - w) / 2;

    return {
      w: Math.round(w),
      h: Math.round(h),
      t: Math.round(t),
      l: Math.round(l)
    };
  }

}

class OfficeScan{

  constructor(){

    this.setup()

    this.render()

    this.loadModel()
      .then(() => {

        // reveal
        this.container.classList.add('is-visible')
        document.querySelector('.loader').classList.add('is-hidden')

        setTimeout(() => {
          this.tweenCamera(cameraPositions.ready, cameraTweenLength)
            .then(() => {
              this.controls.enabled = true
              document.querySelector('canvas').classList.add('is-interactive')
              // this.controls.maxDistance = 12

              // show controls overlay
              document.querySelector('.instructions').classList.add('is-visible')
              window.addEventListener('mousedown', onInitialInteraction, false)


              function onInitialInteraction(){
                window.removeEventListener('mousedown', onInitialInteraction, false)
                document.querySelector('.instructions').classList.remove('is-visible')
              }

            })
        }, 500)
      })

  }

  setup(){

    if(debug){
      this.debug = document.querySelector('.debug')
      this.debug.style.display = 'block'
      this.debugText = 'debug'
    }

    // ********************************************************

    this.container = document.querySelector('.container')

    this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
    })

    this.container.appendChild( this.renderer.domElement )

    // ********************************************************

    this.scene = new THREE.Scene()

    // ********************************************************

    this.camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 0.001, 100)

    this.camera.position.x = cameraPositions.initial.x
    this.camera.position.y = cameraPositions.initial.y
    this.camera.position.z = cameraPositions.initial.z

    window.addEventListener('resize', this.onWindowResize.bind(this), false)
    this.onWindowResize()

    // ********************************************************

    // Orbit Controls
    this.controls = new THREE.OrbitControls( this.camera, this.renderer.domElement )

    this.controls.enableDamping = true
    this.controls.dampingFactor = 0.2

    // this.controls.autoRotate = true
    // this.controls.autoRotateSpeed = 0.25

    this.controls.minDistance = 0.2
    this.controls.maxDistance = Infinity

    this.controls.enablePan = false

    // thou shalt not look straight up or down (it gets confusing)
    this.controls.maxPolarAngle = this.degToRad(170)
    this.controls.minPolarAngle = this.degToRad(10)

    this.controls.target.copy( new THREE.Vector3(targetX, 0, startZ) )

    this.controls.enabled = false

    if(debug){
      this.controls.addEventListener('change', (e) => {
        this.debugText = `${this.camera.position.x} ${this.camera.position.y} ${this.camera.position.z}`
      }, false)
    }

    // ********************************************************

    this.postProcessing()


  }






  postProcessing(){

    this.clock = new THREE.Clock()
    this.composer = new THREE.EffectComposer( this.renderer )

    // clear with a background colour
    let clearPass = new THREE.ClearPass( 0xffffff, 1 )
    this.composer.addPass( clearPass );

    let renderPass = new THREE.RenderPass( this.scene, this.camera )
    renderPass.clear = false
    this.composer.addPass( renderPass )

    this.nodepass = new THREE.NodePass()
    this.nodepass.renderToScreen = true
    this.composer.addPass( this.nodepass )

    let screen = new THREE.ScreenNode()
    let sat = new THREE.FloatNode( 0 )
    sat.number = saturationMultiplier

    var satrgb = new THREE.FunctionNode( [
    "vec3 satrgb(vec3 rgb, float adjustment) {",
    //" const vec3 W = vec3(0.2125, 0.7154, 0.0721);", // LUMA
    " vec3 intensity = vec3(dot(rgb, LUMA));",
    " return mix(intensity, rgb, adjustment);",
    "}"
    ].join( "\n" ) );

    let saturation = new THREE.FunctionCallNode( satrgb )
    saturation.inputs.rgb = screen
    saturation.inputs.adjustment = sat

    this.nodepass.value = saturation

    this.nodepass.build()

  }






  render() {
    requestAnimationFrame(this.render.bind(this))

    TWEEN.update()

    if(this.controls) this.controls.update()
    if(debug && this.debug) this.debug.innerText = this.debugText

    this.delta = this.clock.getDelta()

    this.nodepass.node.updateFrame( this.delta )
    this.composer.render()

  }









  loadModel(){
    let three = this
    return new Promise((resolve, reject) => {

      let text    = document.querySelector('.progress')

      let numErrors = 0

      let loadingManager = new THREE.LoadingManager()
      loadingManager.onProgress = function ( item, loaded, total ) {
        text.innerText = `loading textures ${loaded}/${total}`

        if(loaded === total - numErrors){
          resolve()
        }
      }


      function onProgress( xhr ) {
        if ( xhr.lengthComputable ) {
          var percentComplete = xhr.loaded / xhr.total * 100

          if(percentComplete < 100)
            text.innerText = `downloading model ${Math.round(percentComplete, 2)}%`
          else
            text.innerText = 'rendering model...'
        }
      }

      function onError( xhr ) {
        console.warn(xhr)
        numErrors += 1
      }

      var loader = new THREE.ColladaLoader( loadingManager )

      let url = 'assets/dae/office/sign_join_2.dae'
      loader.load(url, onComplete.bind(three), onProgress, onError)

      function onComplete(collada){
        three = this

        collada.scene.traverse(function( child ){
          if( child instanceof THREE.Mesh ){

            child.castShadow = true
            child.receiveShadow = true
            child.scale.x = child.scale.y = child.scale.z = 0.3
            child.position.y = -0.5

            if(child.material){
              // downgrade the materials to a basic material, using just the texture map
              child.material = child.material.map(m => {
                return new THREE.MeshBasicMaterial({ map: m.map })
              })
            }

            three.scene.add(child)
          }
        })

      }

    })
  }


  onWindowResize(){
    this.renderer.setSize( window.innerWidth, window.innerHeight )
    this.camera.aspect = window.innerWidth / window.innerHeight
    this.camera.updateProjectionMatrix()
  }

  tweenCamera(toVector, duration){
    let three = this

    return new Promise(function(resolve, reject){
      var t = new TWEEN.Tween(three.camera.position)
        .to(toVector, duration )
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onComplete(resolve)

      t.start()
    })
  }




  radToDeg(rad){ return 360 * (rad / (Math.PI*2)) }
  degToRad(deg){ return (deg / 360) * (Math.PI*2) }
  lerp(now, start, end) {
    return (1 - now) * start + now * end
  }

}


function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
    }
  }
}